import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '@epoch-ui/lib/utils';

const slackButtonVariants = cva(
  'tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-p-2 tw-text-background',
  {
    variants: {
      variant: {
        default:
          'tw-bg-transparent tw-border tw-border-solid tw-border-gray-300 tw-text-foreground',
        primary: 'tw-bg-greenSlackButton',
        danger: 'tw-bg-redSlackButton'
      }
    }
  }
);

interface SlackButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof slackButtonVariants> {
  children: React.ReactNode;
}

export const SlackButton: React.FC<SlackButtonProps> = ({ children, variant, ...props }) => {
  return (
    <button type="button" className={cn(slackButtonVariants({ variant }))} {...props}>
      {children}
    </button>
  );
};
